// import { init_backlog_state } from "./backlog.reducer";

export const get_po_intermediate_status = (state) => {
  return state.po_backlog_reducer.backlog.intermediate_states;
};

// export const obj = {
//   completed: null,
//   remaining: null,
//   total: null,
//   progress: null,
// };

export const get_po_upload_progress = (state) => {
  return state.po_backlog_reducer.po.upload_progress;
};

export const get_po_download_progress = (state) => {
  return state.po_backlog_reducer.po.download_progress;
};